import script from "./TerminePage.vue?vue&type=script&setup=true&lang=js"
export * from "./TerminePage.vue?vue&type=script&setup=true&lang=js"

import "./TerminePage.vue?vue&type=style&index=0&id=24a64696&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24a64696"]])

export default __exports__